//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../Tooling/Tooling.SelectReuseLibraryItemBuilder.js";
import "../AME/AME.SelectionBaseDefinitionBuilder.js";
import "../no/Tooling.js";
let d=[[[1,"ReuseLibraryItem",0,"Tooling.SelectReuseLibraryItemBuilder",0],[0,"SelectAll",1,0],[1,"SelectionBaseDefinition",0,"AME.SelectionBaseDefinitionBuilder",0],[0,"TargetRevision",1,0],[0,"Type",1,0]],[[["objectToUpdate"],"AddObjectToUpdate",{},1,0],[["selectionType","numLoadedObjects","loadedObjects"],"LoadAllObjectsUsingType",{},1,0],[["queryObject","numLoadedObjects","loadedObjects"],"LoadAllObjectsUsingQuery",{},1,0],[["sourceDefinition"],"SetSourceEngineeringObjectDefinition",{},1,0]],[]];
SPLM.AME.UpdateObjectsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.UpdateObjectsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.UpdateObjectsBuilder.Types = Object.freeze({
    "Definition" : "Definition", "Query" : "Query"});

SPLM.AME.UpdateObjectsBuilder.ObjectType = Object.freeze({
    "Engobject" : "Engobject", "Product" : "Product", "Symbol" : "Symbol"});

export default SPLM;